import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Salary and overtime details\n          ")
], -1);
const _hoisted_4 = { class: "mb-2" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", {
    for: "minSalary",
    class: "block text-sm font-medium text-gray-700"
}, "\n            What is the proposed salary or hourly rate to offer? *\n          ", -1);
const _hoisted_9 = { class: "flex" };
const _hoisted_10 = ["value", "disabled"];
const _hoisted_11 = ["value", "disabled"];
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("option", null, "GBP", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("option", null, "USD", -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("option", null, "EUR", -1);
const _hoisted_15 = { class: "flex justify-between" };
const _hoisted_16 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_17 = {
    key: 1,
    class: "text-red-500"
};
const _hoisted_18 = { key: 1 };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 italic" }, "* This offer will go for reapproval if the proposed salary is outside of approved range", -1);
const _hoisted_20 = [
    _hoisted_19
];
const _hoisted_21 = { class: "mt-4" };
const _hoisted_22 = { class: "col-span-6 mt-4" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", {
    for: "overtimeRatesInfo",
    class: "block text-sm font-medium text-gray-700"
}, [
    /*#__PURE__*/ _createTextVNode("\n            Please provide overtime rates and when they will apply (e.g. if a specific rate is only applicable at weekend)."),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode("\n            Also use this space for any specific payments due that are not captured in the Additional Allowances section.\n          ")
], -1);
const _hoisted_24 = { class: "mt-4 sm:mt-0 sm:col-span-2" };
const _hoisted_25 = ["value", "disabled"];
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("p", { class: "italic text-red-600" }, "\n              * overtime must be stated within this box. 'Standard' should not be noted. This can delay the processing of the contract.\n            ", -1);
const _hoisted_27 = { class: "mt-4" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("label", {
    for: "additionalAllowances",
    class: "block text-sm font-medium text-gray-700"
}, "\n            Are there any additional allowances associated with this role? *\n          ", -1);
const _hoisted_29 = ["value"];
const _hoisted_30 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_31 = { key: 0 };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-md mt-4" }, "Additional Allowances", -1);
const _hoisted_33 = { class: "mt-4" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("label", {
    for: "salaryReviewMonth",
    class: "block text-sm font-medium text-gray-700"
}, "\n            In which month will the annual salary review take place? *\n          ", -1);
const _hoisted_35 = ["value", "disabled"];
const _hoisted_36 = ["value"];
const _hoisted_37 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_38 = { class: "mt-4" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("label", {
    for: "salaryReviewMonth",
    class: "block text-sm font-medium text-gray-700"
}, "\n            What is the payroll frequency for this role? *\n          ", -1);
const _hoisted_40 = ["value", "disabled"];
const _hoisted_41 = ["selected"];
const _hoisted_42 = ["selected"];
const _hoisted_43 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_44 = { class: "mt-4" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", {
    for: "appraisal",
    class: "block text-sm font-medium text-gray-700"
}, "\n            What type of appraisal will be carried out? *\n          ", -1);
const _hoisted_46 = ["value", "disabled"];
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("option", { value: "Paper based" }, "Paper based", -1);
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("option", { value: "One HR (Online)" }, "One HR (Online)", -1);
const _hoisted_49 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("p", { class: "italic text-red-600" }, "\n          * Employees in job levels 1-4 should be assigned to the OneHR System (online appraisal process).\n        ", -1);
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("p", { class: "italic text-red-600" }, "\n          * Employees in job levels 5-7 will be assigned to the paper based appraisals process unless you select One HR in the dropdown above.\n        ", -1);
const _hoisted_52 = { class: "mt-4" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("label", {
    for: "accountType",
    class: "block text-sm font-medium text-gray-700"
}, "\n            Please confirm the type of account needed for the employee?: *\n          ", -1);
const _hoisted_54 = ["value", "disabled"];
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("option", { value: "Laptop" }, "The employee will be given a company laptop/PC/PDA or smart phone", -1);
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("option", { value: "No Laptop" }, "The employee will not be given any company IT equipment or Microsoft Office account", -1);
const _hoisted_57 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_58 = {
    key: 0,
    class: "p-3 w-full flex flex-row items-center"
};
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-600 ml-2" }, "\n            Once submitted, this document will go for re-approval because the terms have changed.\n          ", -1);
const _hoisted_60 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_61 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CheckList = _resolveComponent("CheckList");
    const _component_ExclamationIcon = _resolveComponent("ExclamationIcon");
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_4, [
                            _createTextVNode("\n            Approved Salary Range:\n            "),
                            (_ctx.atr?.formSix)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.atr?.formSix?.minimumPayRate) + " " + _toDisplayString(_ctx.atr?.formSix?.minimumPayRateCurrency) + " - " + _toDisplayString(_ctx.atr?.formSix?.maximumPayRate) + " " + _toDisplayString(_ctx.atr?.formSix?.maximumPayRateCurrency), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.atr?.atr?.formSix?.minimumPayRate) + " " + _toDisplayString(_ctx.atr?.atr?.formSix?.minimumPayRateCurrency) + " - " + _toDisplayString(_ctx.atr?.atr?.formSix?.maximumPayRate) + " " + _toDisplayString(_ctx.atr?.atr?.formSix?.maximumPayRateCurrency), 1))
                        ]),
                        _createTextVNode(),
                        (_ctx.document.candidate.internal_candidate === 'Yes')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Current Salary: " + _toDisplayString(_ctx.document.candidate.candidateCurrentSalaryRate), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _hoisted_8,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("input", {
                                id: "proposedSalary",
                                value: _ctx.formData?.proposedSalary,
                                name: "proposedSalary",
                                type: "number",
                                min: "0",
                                disabled: _ctx.disableForm,
                                class: "grow block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-md sm:text-sm border-gray-300 disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onInput: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.proposedSalary.$touch()))
                            }, null, 40, _hoisted_10),
                            _createTextVNode(),
                            _createElementVNode("select", {
                                id: "salaryCurrency",
                                value: _ctx.formData?.salaryCurrency,
                                name: "salaryCurrency",
                                disabled: _ctx.disableForm,
                                class: "ml-2 max-w-lg block focus:ring-indigo-500 focus:border-indigo-500 shadow-sm sm:max-w-xs sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:cursor-not-allowed",
                                onChange: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.salaryCurrency.$touch()))
                            }, [
                                _hoisted_12,
                                _createTextVNode(),
                                _hoisted_13,
                                _createTextVNode(),
                                _hoisted_14
                            ], 40, _hoisted_11)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_15, [
                            (_ctx.v$.formData.proposedSalary.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "\n              * " + _toDisplayString(_ctx.v$.formData.proposedSalary.$errors[0].$message), 1))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            (_ctx.v$.formData.salaryCurrency.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "\n              * " + _toDisplayString(_ctx.v$.formData.salaryCurrency.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (!_ctx.salaryIsInRange)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_CheckList, {
                            label: "Please select all overtime options that could apply to this role",
                            name: "overtime",
                            options: _ctx.overtimeOptions,
                            disabled: _ctx.disableForm,
                            "model-value": _ctx.formData?.overtime || [],
                            "onUpdate:modelValue": _ctx.handleUpdateModelValue
                        }, null, 8, ["options", "disabled", "model-value", "onUpdate:modelValue"])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("textarea", {
                                id: "overtime-rates-information",
                                value: _ctx.formData?.overtimeRatesInfo,
                                name: "overtimeRatesInfo",
                                rows: "3",
                                class: _normalizeClass(["shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm,
                                onInput: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                            }, null, 42, _hoisted_25),
                            _createTextVNode(),
                            _hoisted_26
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createTextVNode(),
                        _createElementVNode("input", {
                            id: "additional-allowances-select",
                            value: _ctx.model.additionalAllowances,
                            name: "additionalAllowances",
                            class: "py-2 px-3 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                            disabled: "",
                            onChange: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[6] || (_cache[6] = ($event) => (_ctx.v$.formData.additionalAllowances.$touch()))
                        }, null, 40, _hoisted_29),
                        _createTextVNode(),
                        (_ctx.v$.formData.additionalAllowances.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, "\n            * " + _toDisplayString(_ctx.v$.formData.additionalAllowances.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    (_ctx.model.additionalAllowances && _ctx.model.additionalAllowancesInformation.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _hoisted_32,
                            _createTextVNode(),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.additionalAllowancesInformation, (allowance) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: allowance,
                                    class: "border-b border-gray-200 border-solid my-1 py-4"
                                }, [
                                    _createElementVNode("p", null, "Allowance Type: " + _toDisplayString(allowance.additionalAllowancesInformation), 1),
                                    _createTextVNode(),
                                    _createElementVNode("p", null, "Allowance Amount: £" + _toDisplayString(allowance.additionalAllowanceAmount), 1)
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createTextVNode(),
                        _createElementVNode("select", {
                            id: "salary-review-month-select",
                            value: _ctx.formData?.salaryReviewMonth,
                            disabled: _ctx.disableForm,
                            name: "salaryReviewMonth",
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md w-full disabled:bg-gray-200 disabled:cursor-not-allowed",
                            onChange: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.v$.formData.salaryReviewMonth.$touch()))
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.year, (month) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: month,
                                    value: month
                                }, _toDisplayString(month), 9, _hoisted_36));
                            }), 128))
                        ], 40, _hoisted_35),
                        _createTextVNode(),
                        (_ctx.v$.formData.salaryReviewMonth.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_37, "\n            * " + _toDisplayString(_ctx.v$.formData.salaryReviewMonth.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createTextVNode(),
                        _createElementVNode("select", {
                            id: "payroll-frequency-select",
                            value: _ctx.formData?.payrollFrequency,
                            disabled: _ctx.disableForm,
                            name: "payrollFrequency",
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md w-full disabled:bg-gray-200 disabled:cursor-not-allowed",
                            onChange: _cache[9] || (_cache[9] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[10] || (_cache[10] = ($event) => (_ctx.v$.formData.payrollFrequency.$touch()))
                        }, [
                            _createElementVNode("option", {
                                selected: _ctx.formData?.payrollFrequency === 'Weekly',
                                value: "Weekly"
                            }, "Weekly", 8, _hoisted_41),
                            _createTextVNode(),
                            _createElementVNode("option", {
                                selected: _ctx.formData?.payrollFrequency === 'Monthly',
                                value: "Monthly"
                            }, "Monthly", 8, _hoisted_42)
                        ], 40, _hoisted_40),
                        _createTextVNode(),
                        (_ctx.v$.formData.payrollFrequency.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, "\n            * " + _toDisplayString(_ctx.v$.formData.payrollFrequency.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createTextVNode(),
                        _createElementVNode("select", {
                            id: "appraisal-select",
                            value: _ctx.formData?.appraisal,
                            disabled: _ctx.disableForm,
                            name: "appraisal",
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md w-full disabled:bg-gray-200 disabled:cursor-not-allowed",
                            onChange: _cache[11] || (_cache[11] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[12] || (_cache[12] = ($event) => (_ctx.v$.formData.appraisal.$touch()))
                        }, [
                            _hoisted_47,
                            _createTextVNode(),
                            _hoisted_48
                        ], 40, _hoisted_46),
                        _createTextVNode(),
                        (_ctx.v$.formData.appraisal.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_49, "\n            * " + _toDisplayString(_ctx.v$.formData.appraisal.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _hoisted_50,
                    _createTextVNode(),
                    _hoisted_51,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createTextVNode(),
                        _createElementVNode("select", {
                            id: "account-type-select",
                            value: _ctx.formData?.accountType,
                            disabled: _ctx.disableForm,
                            name: "accountType",
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md w-full disabled:bg-gray-200 disabled:cursor-not-allowed",
                            onChange: _cache[13] || (_cache[13] =
                                //@ts-ignore
                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                            onBlur: _cache[14] || (_cache[14] = ($event) => (_ctx.v$.formData.accountType.$touch()))
                        }, [
                            _hoisted_55,
                            _createTextVNode(),
                            _hoisted_56
                        ], 40, _hoisted_54),
                        _createTextVNode(),
                        (_ctx.v$.formData.accountType.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, "\n            * " + _toDisplayString(_ctx.v$.formData.accountType.$errors[0].$message), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createTextVNode(),
                (!_ctx.salaryIsInRange)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createVNode(_component_ExclamationIcon, { class: "text-red-600 h-16 w-16" }),
                        _createTextVNode(),
                        _hoisted_59
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createTextVNode(),
            (_ctx.editable || (!_ctx.disableForm && _ctx.document.currentStageName === 'offer.notifyPrepOffer'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[15] || (_cache[15] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_61)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
